import { useLoggedInQuery } from '@/src/common/gql/MesaGql'
import { graphql } from '@api/mesa'
import { useLogError } from '@/src/common/hooks/useLogError'
import { useEffect } from 'react'

const GEO_LOOKUP = graphql(`
  query GeoLookup {
    geoLookup {
      __typename
      ... on InferredGeolocationModel {
        city
        stateCode
        countryCode
      }
      ... on GeolocationInferenceFailedModel {
        errorMessage
      }
    }
  }
`)

export function useStateCode() {
  const onError = useLogError()
  const {
    data: geoLookupData,
    loading: loadingGeoState,
    error,
  } = useLoggedInQuery(GEO_LOOKUP, { onError })

  useEffect(() => {
    if (geoLookupData?.geoLookup) {
      if (geoLookupData.geoLookup.__typename === 'GeolocationInferenceFailedModel') {
        onError(geoLookupData.geoLookup.errorMessage, geoLookupData.geoLookup)
      } else if (!geoLookupData.geoLookup.stateCode) {
        onError('geo lookup gave an empty state code', geoLookupData.geoLookup)
      }
    }
  }, [onError, geoLookupData])

  if (!geoLookupData && !error) {
    return 'uninitialized'
  }

  if (loadingGeoState) {
    return 'loading'
  }

  if (geoLookupData && 'stateCode' in geoLookupData.geoLookup) {
    const stateCode = geoLookupData.geoLookup.stateCode
    if (stateCode) {
      return { stateCode } as const
    }
  }

  return 'error'
}
